import { useContext } from 'react';
import { UserAuthContext } from '../authenticationProvider';

export const useAuthenticationState = () => {
    const {
        authenticationState,
        shouldBootstrapUser,
        setAuthenticationStateJWT,
        setAuthenticationStateLogin
    } = useContext(UserAuthContext) as any;

    return {
        authenticationState,
        shouldBootstrapUser,
        setAuthenticationStateJWT,
        setAuthenticationStateLogin
    };
}
